/**
 * This file contains utilities for string transformations
 * */
import Locales from '../constants/locales';

export const capitalizeFirstLetterOfString = (str = '') => (
  str ? str[0].toUpperCase() + str.slice(1).toLowerCase() : str
);

export const replaceInString = (string, replace, replacer) => (
  string.replace(new RegExp(replace), replacer)
);

export const interpolateString = (template, data) => {
  const braceRegex = /{(.*?)}/g;
  return template && template.replace(braceRegex, (_, key) => {
    let result = data;
    key.split('.').forEach((property) => {
      result = result ? result[property] : '';
    });
    return String(result);
  });
};

export const getFormattedAmountWithCurrency = (amount, locale) => {
  const formattedAmount = amount.toLocaleString(locale);

  switch (locale) {
    case Locales.HI_IN:
    case Locales.EN_IN:
      return `₹${formattedAmount}`;
    case Locales.EN_US:
      return `₹${formattedAmount}`;

    default:
      return formattedAmount;
  }
};

/*
* Input: Key length (default: 40)
* Output: 'b192eb8b55a7a31ce3b7'
 */
export const getUniqueKey = (length = 40) => {
  const uintArray = new Uint8Array((length) / 2);
  window.crypto.getRandomValues(uintArray);

  return Array.from(uintArray, (decimal) => (
    decimal.toString(16).padStart(2, '0'))).join('');
};

/*
* Input: 'firstPartyOVDType'
* Output: 'First Party OVD Type'
*/
export const transformCamelCase = (input) => {
  const result = input
    // Insert a space before an uppercase letter that is preceded by a lowercase letter
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    // Insert a space before a lowercase letter that is preceded by an uppercase letter
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    // Uppercase the first character of each word
    .replace(/(^|[\s-])[a-z]/g, (str) => str.toUpperCase());
  return result;
};
